let container = null;

export function getContextMenuPortalContainer() {
  if (container && document.documentElement.contains(container)) return container;
  container = document.createElement('div');
  container.id = 'ctx-menu-root';
  Object.assign(container.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zoom: '1',
    pointerEvents: 'none',
    zIndex: '9999',
    fontFamily: 'Aeonik',
  });
  document.documentElement.appendChild(container);
  return container;
}

export function rightClickContextMenu(e) {
  const event = new MouseEvent("contextmenu", {
    bubbles: true,
    cancelable: true,
    view: window,
    button: 2,
    clientX: e.clientX,
    clientY: e.clientY,
    screenX: e.screenX,
    screenY: e.screenY,
    pageX: e.pageX,
    pageY: e.pageY
  })
  e.currentTarget.dispatchEvent(event)
}

export function openContextMenuAt(targetEl, clientX, clientY) {
  if (!targetEl) return;
  const event = new MouseEvent("contextmenu", {
    bubbles: true,
    cancelable: true,
    view: window,
    button: 2,
    clientX,
    clientY
  })
  targetEl.dispatchEvent(event)
}